module.exports = __webpack_public_path__ + "media/แบ๊ะๆ.b769e61e.mp3";